import type { Components } from '@mui/material'

export const OmuiStatusBar: NonNullable<Components['OmuiStatusBar']> = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape['futureTheme.radius-full'],
      padding: theme.spacing(1.5, 2, 1.5, 3),
      '& > div': {
        minHeight: 28,
      },
      '& .OmuiStatusBar-actionContainer': {
        gap: theme.spacing(2),
      },
    }),
    message: ({ theme }) => ({
      ...theme.typography['futureTheme.body-medium'],
    }),
    divider: ({ theme }) => ({
      borderColor: theme.palette.futureTheme.border.subtle,
      borderRightWidth: theme.futureTheme.strokeWidth.default,
    }),
    icon: {
      '& .MuiCircularProgress-root': {
        color: 'inherit',
      },
    },
    closeButton: {
      width: 24,
      height: 24,
    },
  },
  variants: [
    {
      props: { variant: 'loading' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.surface.elevated,
        color: theme.palette.futureTheme.text.default,
        borderWidth: theme.futureTheme.strokeWidth.default,
        borderColor: theme.palette.futureTheme.border.subtle,
        borderStyle: 'solid',

        '& .OmuiStatusBar-icon': {
          color: theme.palette.futureTheme.fg.default,
        },
      }),
    },
    {
      props: { variant: 'success' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.success.default,
        color: theme.palette.futureTheme.text.success.onSuccess,
        '& .OmuiStatusBar-divider': {
          borderColor: theme.palette.futureTheme.border.transparent,
        },
        '& .OmuiStatusBar-icon': {
          color: theme.palette.futureTheme.fg.success.onSuccess,
        },
        '& .OmuiStatusBar-closeButton': {
          color: theme.palette.futureTheme.fg.success.onSuccess,
        },
      }),
    },
    {
      props: { variant: 'error' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.danger.default,
        color: theme.palette.futureTheme.text.danger.onDanger,
        '& .OmuiStatusBar-divider': {
          borderColor: theme.palette.futureTheme.border.transparent,
        },
        '& .OmuiStatusBar-icon': {
          color: theme.palette.futureTheme.fg.danger.onDanger,
        },
        '& .OmuiStatusBar-closeButton': {
          color: theme.palette.futureTheme.fg.danger.onDanger,
        },
      }),
    },
    {
      props: { variant: 'warning' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.futureTheme.bg.warning.default,
        color: theme.palette.futureTheme.text.warning.onWarning,
        '& .OmuiStatusBar-divider': {
          borderColor: theme.palette.futureTheme.border.transparent_inverted,
        },
        '& .OmuiStatusBar-icon': {
          color: theme.palette.futureTheme.fg.warning.onWarning,
        },
        '& .OmuiStatusBar-closeButton': {
          color: theme.palette.futureTheme.fg.warning.onWarning,
        },
      }),
    },
  ],
}
